import ViewBase from '../framework/core/mvvm/view_base';
import { CountUp } from '../lib/countUp';
import LanguageManager from '../manager/language_manager';
import { setFlagsFromString } from 'v8';
import EditorBoxCenter from '../pacakge/public/ui/editor_box_center';
import *  as ConfigLanguageData from '../lib/ConfigLanguageData';
const { ccclass, menu, property, executeInEditMode, inspector } = cc._decorator;

@ccclass
@menu('UI/ULabel')
@executeInEditMode
export default class ULabel extends cc.Component {
    @property(ViewBase)
    viewBase: ViewBase = null;
    private _init: boolean
    private targetComponent: cc.Label
    @property()
    public i18nKey: string = ""
    public onChangeLanguage() {
        this.targetComponent.string = LanguageManager.t(this.i18nKey)

    }

    onEnable() {
        if (!this._init) {
            this._init = true
            this.targetComponent = this.getComponent<cc.Label>(cc.Label)
            if (this.viewBase) {
                this.viewBase.cacheComponent(this.node.name, this)
            }
        }
    }
    protected resetInEditor() {
        if (this.viewBase == null) {
            let parent = this.node
            while (parent != null) {
                this.viewBase = parent.getComponent<ViewBase>(ViewBase)
                if (this.viewBase != null) {
                    break;
                }
                parent = parent.parent
            }
        }
    }
    //编辑器模式下的更新
    updateLabel()
    {  
        //cc.log("编辑器模式下更新");
        if (!this.targetComponent) {
            cc.error('Failed to update Ulabel, label component is invalid!');
            return;
        }
        //cc.log("this.targetComponent:"+this.targetComponent.string);
        let localizedString = ConfigLanguageData.parse(this.i18nKey);
        if (localizedString) {
            this.targetComponent.string = ConfigLanguageData.parse(this.i18nKey);
        }
    }
}
